import React, { useEffect } from 'react';

import { BOOK_FORM, CANT_CONFIRM_SPECIALTIES, CANT_CONFIRM_SPECIALTIES_TEXT } from 'constants/bookingConstants';
import { getLoadTypeText, getLoadRequirementsText } from 'helpers/bookingModalTextHelpers';

import RadioButton from '@arrive/radio-button'

import styles from './BookingModal.scss';
import { useFlags } from 'launchdarkly-react-client-sdk';

const boldSpecialties = (string: string | boolean) => {
  if (typeof string === "string") {
    const array = string.split(" ");
    return array.map((word, index) => {
      if (word === "and") {
        return <>{word} </>;
      } else if (word.includes(",")) {
        return (
          <>
            <strong key={index}>{word.slice(0, -1)}</strong>,{" "}
          </>
        );
      }
      return <strong key={index}>{word} </strong>;
    });
  }
  return null
};

interface Props {
  specialEquipment: string | boolean;
  loadRequirements: string | boolean;
  specialServicesData: any;
  loadNumber: number;
  setBinStatus: (status: string) => void;
  binStatus: string;
  setConfirmSpecialtiesState: (id: string) => void
  confirmSpecialtiesState: string;
}

export default function BookingModalConfirmSpecialities({ specialEquipment, loadRequirements, specialServicesData, loadNumber, setBinStatus, binStatus, confirmSpecialtiesState, setConfirmSpecialtiesState }: Props) {
  const { FEATURE_LOAD_SPECIAL_SERVICES } = useFlags();
  useEffect(() => {
    if (window.pendo) {
      const pendoInfo = {
        specialEquipment: specialEquipment,
        loadRequirements: loadRequirements,
        loadNumber
      };

      window.pendo.track('BIN > Special Reqs Open', pendoInfo);
    }
  }, [loadNumber, loadRequirements, specialEquipment])

  const loadTypeText = getLoadTypeText(specialServicesData);
  const loadRequirementsText = getLoadRequirementsText(specialServicesData);
  const formattedLoadRequirementsText = loadTypeText?.length && loadRequirementsText?.length ? <>that {loadRequirementsText}</> : loadRequirementsText


  return (
    <div className={styles.listContent}>
      <div className={styles.header}>Can you meet the requirements for this load?</div>
      {
        FEATURE_LOAD_SPECIAL_SERVICES ?
          <div className={styles.subHeader}><>Select &apos;Yes&apos; to confirm you understand that this {loadTypeText} load{!!loadRequirementsText?.length && <> {formattedLoadRequirementsText}</>}.</></div> :
          <div className={styles.subHeader}>{<>Select &apos;Yes&apos; to confirm you understand this is a {loadRequirements ? boldSpecialties(loadRequirements) : boldSpecialties(specialEquipment)}{(loadRequirements && specialEquipment) ? <>load that requires {boldSpecialties(specialEquipment)}equipment.</> : <>load.</>}</>}</div>
      }
      <div className={styles.radioContainer}>
        <RadioButton className={styles.leftRadioButton} label="Yes" value="Yes" asButton checked={confirmSpecialtiesState === "Yes"} onChange={(event) => {
          setConfirmSpecialtiesState(event.target.id); setBinStatus(BOOK_FORM)
        }} />
        <RadioButton label="No" value="No" asButton checked={confirmSpecialtiesState === "No"} onChange={(event) => {
          setConfirmSpecialtiesState(event.target.id); setBinStatus(CANT_CONFIRM_SPECIALTIES)
        }} />
      </div>
      {binStatus === CANT_CONFIRM_SPECIALTIES && <div className={styles.cantConfirmText}>{CANT_CONFIRM_SPECIALTIES_TEXT}</div>}
    </div>
  )
}
